import { render } from "./ReceiveProducts.vue?vue&type=template&id=9b4163c6&scoped=true"
import script from "./ReceiveProducts.vue?vue&type=script&lang=js"
export * from "./ReceiveProducts.vue?vue&type=script&lang=js"

import "./ReceiveProducts.vue?vue&type=style&index=0&id=9b4163c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b4163c6"]])

export default __exports__